<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import BaseBadge from '@/components/ui/BaseBadge.vue'
import { useMapStore } from '@/stores/mapStore'

defineOptions({ name: 'MapZoomIndicator' })

const mapStore = useMapStore()
const { currentZoom } = storeToRefs(mapStore)
const zoomLabel = computed(() =>
  currentZoom.value === null ? 'Zoom —' : `Zoom ${currentZoom.value.toFixed(1)}`,
)
const zoomAriaLabel = computed(() =>
  currentZoom.value === null
    ? 'Current zoom unavailable'
    : `Current zoom level ${currentZoom.value.toFixed(1)}`,
)
</script>

<template>
  <BaseBadge size="sm" tone="neutral" class="shrink-0 tabular-nums" :aria-label="zoomAriaLabel">
    {{ zoomLabel }}
  </BaseBadge>
</template>
